import { render, staticRenderFns } from "./AgentTransactionsReportPatentList.vue?vue&type=template&id=510ba4ad&"
import script from "./AgentTransactionsReportPatentList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportPatentList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportPatentList.vue?vue&type=style&index=0&id=510ba4ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports